import React, { useState, useEffect } from "react";

const CDAModal = ({ isOpen, onAgree, onClose }) => {
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;

      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";

      return () => {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";

        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleAgree = () => {
    if (isAgreed) {
      onAgree();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-black text-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto border border-4 border-[#22AAEE] border-solid">
        <div className="text-center py-6 px-6">
          <h2 className="text-xl font-semibold">
            Consent & Disclosure Agreement (Required Before Entry)
          </h2>
        </div>

        <div className="px-6 text-sm leading-relaxed">
          <p>
            Welcome to Plutonic’s Virtual Mental Health Companion. Before
            continuing, please carefully read and agree to the following:
          </p>
          <p>
            Plutonic’s AI Mental Health Companion is not a licensed therapist,
            medical provider, or crisis resource. It is intended for general
            emotional wellness support and coaching, and does not provide
            medical advice, diagnosis, therapy, or treatment. Use of this
            platform does not establish a provider-patient relationship.
          </p>

          <p>By continuing, you acknowledge and agree that:</p>

          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              You are not currently experiencing a mental health crisis,
              suicidal thoughts, or urges to harm yourself or others.
            </li>
            <li>
              If you are in crisis or feel unsafe, you must not use this
              platform and instead contact 911, the Suicide & Crisis Lifeline at
              988, or go to the nearest emergency room.
            </li>
            <li>
              The AI companion is not a substitute for licensed therapy,
              psychiatric care, or medical advice.
            </li>
            <li>
              Some interactions with the chatbot may be reviewed by authorized
              Plutonic staff for safety monitoring and quality assurance. These
              reviewers are trained in confidentiality and all data is stored
              securely.
            </li>
            <li>
              If you are enrolled in therapy through Plutonic, your licensed
              therapist may review your chatbot interactions as part of your
              care plan.
            </li>
            <li>
              All data is handled using HIPAA-compliant systems and
              infrastructure, and in accordance with Plutonic’s Privacy Policy
              and Terms of Use.
            </li>
            <li>
              You retain the right to access, request, or delete your personal
              data, as permitted by law.
            </li>
          </ul>

          <div className="flex items-start space-x-2 mt-4">
            <input
              type="checkbox"
              id="agreement-checkbox"
              className="mt-1 text-blue-600 bg-transparent border-gray-300 rounded focus:ring-blue-500"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              required
            />
            <label htmlFor="agreement-checkbox" className="text-sm">
              I understand and agree that Plutonic’s AI mental health companion
              is not therapy or medical treatment, and that some interactions
              may be reviewed by authorized staff or my licensed therapist (if
              applicable) for safety or care purposes. I agree to the Privacy
              Policy and Terms of Use.
            </label>
          </div>
        </div>

        <div className="flex justify-center py-6 px-6">
          <button
            onClick={handleAgree}
            disabled={!isAgreed}
            className={`px-16 py-2 rounded-full font-medium transition-colors duration-200 ${
              isAgreed
                ? "bg-[#d8f8ff] hover:bg-[#a8ffff] text-black cursor-pointer"
                : "bg-gray-400 text-gray-200 cursor-not-allowed"
            }`}
          >
            Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default CDAModal;
